import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

function DndList({
  list = [],
  draggableKey = 'id',
  onChange,
  renderItem,
  direction = 'horizontal',
  sortMode,
}) {
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = result => {
    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }

    const newList = reorder(list, result.source.index, result.destination.index);
    onChange(newList);
  };

  if (!sortMode) {
    return list.map((item, index) => renderItem(item, index));
  }

  return (
    <div className="dnd-list-container">
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId={draggableKey} direction={direction}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={`dnd-droppable ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
              style={{
                display: 'flex',
                flexWrap: direction === 'horizontal' ? 'wrap' : 'nowrap',
                gap: '16px',
                width: '100%'
              }}
            >
              {list.map((item, index) => (
                <Draggable key={`${item[draggableKey]}`} draggableId={`${item[draggableKey]}`} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`dnd-draggable ${snapshot.isDragging ? 'is-dragging' : ''}`}
                      style={{
                        ...provided.draggableProps.style,
                        // Ensure proper touch behavior
                        touchAction: 'none',
                      }}
                    >
                      {renderItem(item)}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}

export default DndList;
